import { get_ai_download_url } from 'services/db-service';
import { backendFetch } from 'services/backend-auth';
import { parseMediaReference } from 'services/media';
import React, { useEffect, useState } from 'react'; 
import { RootState } from 'app/store/rootReducer';  
import { fetchPost } from './postPreviewSlice';
import { useParams } from "react-router-dom"; 
import { SEO } from 'components/SEO';
import { useDispatch, useSelector } from 'react-redux';
import AppError from 'components/Error';
import renderer, { replaceIPFSVideoLinks, removePrimaryVideo } from 'helpers/contentRenderer';
import YouTubeEmbed from './youtubeEmbed';
import { getTimeAgo, getTimeToExpiration, renderHTMLSafe, extractIPFSLink } from 'services/posts-service';
import { useAuth } from 'helpers/authContext'; 
import 'antd/dist/reset.css';  
import { Alert } from 'reactstrap'; 
import { getUserFollowingList } from 'services/user-service'; 
import useModal from 'helpers/useModal';
import LoginModal from 'features/user/userModals/LoginModal';
import PostVideoItem from './postVideoItem';
import AdSense from 'components/AdSense';
import { setSteemConfig } from 'config';  
import FollowButton from 'components/FollowButton'; 
import PostReplies from 'components/PostReplies';
import VoteButton from 'components/VoteButton';
import ShareButton from 'components/ShareButton';
import ContentEditPostModal from 'features/content/contentModals/ContentEditPostModal';
import { custom_post_queue, get_plans, get_views, register_view, get_ipfs_metadata, update_ipfs_metadata, aiBackend, download_video } from 'services/db-service';
import RewardsButton from 'components/RewardsButton';
import ActiveVotesButton from 'components/ActiveVotesButton';
import VideoPlayer from "components/VideoPlayer"; 
import { getReputation } from 'services/dsteem-service';
import { VerifiedIcon } from 'components/VerifiedIcon'; 
import Skeleton from 'react-loading-skeleton';
import { Spinner } from 'reactstrap';
import classnames from 'classnames';

export const PostPreviewPage = () => {
    const dispatch = useDispatch();
    const { isOpenLoginModal, toggleLoginModal } = useModal();
    const { username, permlink } = useParams(); 
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const { user, updateFollowing, rpc_node, app_settings, recently_viewed, updateRecentlyViewed } = useAuth(); 
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [localReplies, setLocalReplies] = useState([]); 
    const [userPlans, setUserPlans] = useState([]);
    const [views, setViews] = useState([]);
    const [viewRegistered, setViewRegistered] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadStatus, setDownloadStatus] = useState("");
 
    const cumulativeWatchTimeRef = React.useRef<number>(0);
    const lastTimeUpdateRef = React.useRef<number>(0);
    const [suggestedPosts, setSuggestedPosts] = useState([]);
    const autoplaySetting = app_settings.autoplay;
    // const videoRef = useRef<HTMLVideoElement | null>(null);
    // const [isPlaying, setIsPlaying] = useState(autoplaySetting);  
    const [activeTab, setActiveTab] = useState('post');
    const [ipfsCid, setIpfsCid] = useState<string | null>(null);
    const [aiTranscription, setAiTranscription] = useState<string | null>(null);
    const [aiLanguage, setAiLanguage] = useState<string | null>(null);
    const [aiSrt, setAiSrt] = useState<string | null>(null);
    const [transcriptionViewMode, setTranscriptionViewMode] = useState<'text' | 'srt'>('text');
    const [aiProcessing, setAiProcessing] = useState(false);
    const [aiStatus, setAiStatus] = useState('');
    const {
      post,
      error: contentError,
      isLoading
    } = useSelector((state: RootState) => state.post); 

    const onNewError = (message) => {
      setErrorMessage(message); 
      setTimeout(() => { setErrorMessage(null); }, 15000);
    } 
    const reloadFollowing = () => {
      if (user) {
        getUserFollowingList(user).then(result => { 
          updateFollowing(result);
        });
      } 
    }; 
    useEffect(() => {
      const getViews = async () => { 
        let data = await get_views();
        setViews(data); 
      }
      getViews();
      const getPlans = async () => { 
        let data = await get_plans(); 
        setUserPlans(data); 
      }
      getPlans(); 
    }, []);
    useEffect(() => {
      try {
        if (post && recently_viewed) {
          const viewedList = recently_viewed;
          const postUrl = `/@${post.author}/${permlink}`;
          const today = new Date().toISOString().slice(0, 10); 
          let alreadyViewed = false; 
          
          if (viewedList) {
            alreadyViewed = viewedList.find(
              (view) => view.url === postUrl && view.date === today
            );
          }
          
          if (alreadyViewed) {
            setViewRegistered(true);
          }
        }
      } catch (error) {
        console.log(error);
        
      } 
    }, [recently_viewed, post]); 
    const handleVideoTime = (currentTime: number, duration: number = 0) => {
      const delta = currentTime - lastTimeUpdateRef.current;
      if (delta > 0 && delta < 3.0) {
        cumulativeWatchTimeRef.current += delta;
      }
      lastTimeUpdateRef.current = currentTime;

      const safeDuration = (duration && isFinite(duration) && duration > 0) ? duration : 0;
      const requiredTime = safeDuration > 0 ? (safeDuration * 0.1) : 5;

      if (cumulativeWatchTimeRef.current >= requiredTime && !viewRegistered) { 
        setViewRegistered(true);
        console.log("Adding new view"); 
        register_view(post.author, post.permlink, recently_viewed, updateRecentlyViewed, user);
      }
    };

    useEffect(() => { 
      setViewRegistered(false);
      cumulativeWatchTimeRef.current = 0;
      lastTimeUpdateRef.current = 0;
      if (user) {
        reloadFollowing(); 
      } 
      if (username && permlink) { 
        window.scrollTo(0, 0);
        setSteemConfig(rpc_node); 
        dispatch(fetchPost(username, permlink));  
        // dispatch(fetchPosts("steemvideo", "trending", true, true, 10));  
        const loadSuggested = async () => {
          try {
            const feed = await custom_post_queue(user || null, 15);
            setSuggestedPosts(feed.filter(p => p.author !== username || p.permlink !== permlink));
          } catch (error) {
            console.log("Error loading suggested feed", error);
          }
        };
        loadSuggested();
      }
    }, [username, permlink]);  

    useEffect(() => {
        if (!post?.body) return;

        const ipfsUrl = extractIPFSLink(post.body, post.json_metadata);
        const cid = parseMediaReference(ipfsUrl)?.cid;
        if (!cid) return;
        console.log('[PostPreview] CID extracted:', cid);
        setIpfsCid(cid);

        get_ipfs_metadata(cid)
            .then((cache: any) => {
                console.log('[PostPreview] IPFS metadata cache:', cache);
                if (cache && cache.transcription && cache.transcription.trim() !== '') {
                    setAiTranscription(cache.transcription);
                    if (cache.language) setAiLanguage(cache.language);
                    if (cache.srt_content) setAiSrt(cache.srt_content);
                }
            })
            .catch((e: any) => console.log('[PostPreview] Error loading IPFS metadata', e));
    }, [post]);

    useEffect(() => {
      if (!user) return;

      let mounted = true;
      const run = async () => {
        const result = await getUserFollowingList(user);
        if (mounted) updateFollowing(result); 
      };
      run(); 
    }, [user]); 



    const handleShare = () => { 
      const shareUrl = window.location.href; 
      if (navigator.share) {
        navigator.share({
          title: post ? post.title : 'Look this video',
          url: shareUrl,
        }).then(() => console.log('Shared successfully.'))
        // .catch((error) => onNewError('Error sharing' + error));
      } else { 
        alert(`Copy to share: ${shareUrl}`);
      }
    };

    if (contentError) {
      return (
        <AppError />
      )
    };

    const generateTranscriptionFromIPFS = async () => {
        if (!ipfsCid || !user) return;
        setAiProcessing(true);
        setAiStatus('Downloading IPFS object...');
        
        try {
            const res = await backendFetch(`${aiBackend}/api/v1/process_ipfs`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    cid: ipfsCid,
                    username: user,
})
            });
            const data = await res.json();
            
            if (data.task_id) {
                setAiStatus('Generating...');
                const interval = setInterval(async () => {
                    try {
                        const poll = await backendFetch(`${aiBackend}/api/v1/task/${data.task_id}`);
                        const pollData = await poll.json();
                        if (pollData.status === 'completed') {
                            setAiStatus('');
                            setAiProcessing(false);
                            const result = pollData.result;
                            setAiTranscription(result.transcription);
                            if (result.srt_content) setAiSrt(result.srt_content);
                            update_ipfs_metadata(
                                ipfsCid, 
                                result.ai_metadata, 
                                result.transcription, 
                                user, 
                                result.language, 
                                result.srt_content,
                                result.transcription_en,
                                result.srt_content_en
                            );
                            clearInterval(interval);
                        } else if (pollData.status === 'failed') {
                            setAiStatus('');
                            setAiProcessing(false);
                            onNewError(pollData.error || "AI task failed");
                            clearInterval(interval);
                        } else {
                            setAiStatus(`Status: ${pollData.status}`);
                        }
                    } catch (e: any) {
                        clearInterval(interval);
                        setAiProcessing(false);
                        onNewError('Polling error: ' + e.message);
                    }
                }, 3000);
            } else {
                setAiProcessing(false);
                onNewError(data.message || 'Error initing task');
            }
        } catch(e) {
            setAiProcessing(false);
            onNewError('Network error starting AI task');
        }
    };

    const handleDownloadVideo = async () => {
      if (!user) { toggleLoginModal(); return; }
      if (!ipfsCid) {
        alert("This video cannot be downloaded (IPFS CID not found).");
        return;
      }

      setIsDownloading(true);
      setDownloadStatus("Starting...");

      try {
        const res = await download_video(ipfsCid, user || "guest");
        if (res && res.task_id) {
          setDownloadStatus("Queued...");
          const interval = setInterval(async () => {
            try {
              const poll = await backendFetch(`${aiBackend}/api/v1/task/${res.task_id}`);
              const data = await poll.json();

              if (data.status === 'completed') {
                setDownloadStatus("Ready!");
                setIsDownloading(false);
                clearInterval(interval);
                
                // Trigger actual browser download
                const link = document.createElement('a');
                link.href = await get_ai_download_url(data.result.filename);
                link.setAttribute('download', data.result.filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                setTimeout(() => setDownloadStatus(""), 3000);
              } else if (data.status === 'failed') {
                setIsDownloading(false);
                setDownloadStatus("Error");
                alert("Download failed: " + (data.error || "Unknown error"));
                clearInterval(interval);
              } else {
                setDownloadStatus(data.status === 'processing' ? "Processing..." : "Queued...");
              }
            } catch (e) {
              console.error("Polling error", e);
            }
          }, 3000);
        } else {
          setIsDownloading(false);
          setDownloadStatus("Error");
        }
      } catch (e) {
        setIsDownloading(false);
        setDownloadStatus("Error");
        console.error(e);
      }
    };

    let BodyText;
    let videoEmbed;
    let renderContent;
    let title;
    let timeAgoString; 
    let postStatus;
    let postButtons; 
    let postDescription; 
    let channelDetails;
    let tagsList; 
    let userData;
    let labels;
    let isVideo = false;
    let isIPFS = false;
    let isYoutube = false;
    let isShort = false;
    let isComment = false;
    let tags = [];
    let exist = true;
    if (!isLoading) {  
      try { 
        if (post && post?.author) { 
          userData = post.user[0];   
          let url = null;
          if (post.video && typeof post.video === 'string') {
            isVideo = true;
            if (post.video.includes('ipfs')) {
              isIPFS = true;
              url = post.video; 
            } else { 
              isYoutube = true;
              if (post.video.includes('/shorts')) {
                isShort = true;
              }
              url = post.video.replace("youtu.be","www.youtube.com/embed").replace("www.youtube.com/shorts","www.youtube.com/embed");
            }
          } else if (post.video?.files?.youtube) {
            url = "https://www.youtube.com/embed/" + post.video.files.youtube;
          }

          if (post.depth > 0) {
            isComment = true;
          } 
          
          if (url && url.includes('ipfs')) { 
            videoEmbed = ( 
              <VideoPlayer
                url={url}
                cover={post.cover}
                post={post}
                autoplay={autoplaySetting}  
                onTimeUpdate={handleVideoTime}
              />
            );
          } else if (url && (url.includes('youtube') || url.includes('youtu.be'))) { 
            videoEmbed = (
              <YouTubeEmbed
                url={url}
                coverImageUrl={post.cover || ""}
                author={post.author}
                permlink={post.permlink}
              />
            );
          }

          if (post.title) {
            title = (
              <h1 className='post-video-title'>{post.title}</h1>
            ); 
          } 
          let body = removePrimaryVideo(post.body, url);
          
          try {
            let coverCopy = (post.depth == 0) ? post.cover : "";
            let videoCopy = url || ""; 
            if (url && url != "") { 
              if (url && url.includes('ipfs')) { 
                const escapedUrl = url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); 
                body = body.replace(
                  new RegExp(`\\[IPFS Video\\]\\(${escapedUrl}\\)`, "gi"),
                  ""
                ); 
                body = body.replace(
                  new RegExp(`<a[^>]+href=["']${escapedUrl}["'][^>]*>.*?<\\/a>`, "gi"),
                  ""
                );
              }

              body = body.replace(/\?si=[a-zA-Z0-9_-]+/, "") 
                      .replace(/\?feature=[a-zA-Z0-9_-]+/, "")
                      .replace(coverCopy,"")
                      .replace(videoCopy,"")
                      .replace(url,"") 
                      .replace(videoCopy.replace("www.youtube.com/embed","youtu.be") || "","")
                      .replace(videoCopy.replace("www.youtube.com/embed/","www.youtube.com/watch?v=") || "","") 
                      .replace(videoCopy.replace("www.youtube.com/embed","youtu.be").split("?")[0]  || "","")
                      .replace(/!\[.*?\]\(\)/g, "")
                      .replace(/<iframe.*?<\/iframe>/g, "")
                      .replace(/<img[^>]*src=["']\s*["'][^>]*>/gi, "")
                      //.replace(/\[IPFS Video\]\((https?:\/\/[^\s)]+\/ipfs\/[^\s)]+)\)/gi, ""); 
            } 
            BodyText = body;
            renderContent = (
              renderHTMLSafe(replaceIPFSVideoLinks(renderer.render(body)))
            );  
            if (post.depth == 0) {
              if (videoEmbed) {
                postDescription = (
                  <div className='video-description-content'>
                    <h3 className='post-video-description-title'>Description:</h3>
                    <div className="mt-3 body-content">{renderContent}</div>
                  </div>
                );
              }else {
                renderContent = (
                  renderHTMLSafe(replaceIPFSVideoLinks(renderer.render(post.body)))
                );  
                videoEmbed = (
                  <div className='video-description-content p-3'>
                    {title}
                    <div className="mt-3 body-content">{renderContent}</div>
                  </div>
                );
                title = "";
              }
              
            }else {
              videoEmbed = (
                <div className='video-description-content p-3'>
                  <h3 className='depth-notice'>This is a comment for <a href={`/p/${post.root_author}/${post.root_permlink}`}>{`/@${post.root_author}/${post.root_permlink}`}</a></h3>
                  <div className="mt-3 body-content">{renderContent}</div>
                </div>
              );
            } 
          } catch (error) {
            console.log("While parsing body", error); 
          }  
          
          timeAgoString = getTimeAgo(post.created); 
          let payouTimeString = getTimeToExpiration(post.created); 
          postStatus = (
            <div className="post-buttons post-stats-mobile"> 
              <span className="btn post-tools no-action">
                <i className="fas fa-clock" /> {timeAgoString}
              </span>
              <span className="btn post-tools no-action" title="0">
                  <i className="fas fa-eye" /> {post.views || 0}
                </span>
            </div>
          );
          postButtons = (
            <div className="post-buttons"> 
              <div className="post-stats-desktop">  
                <span className="btn post-tools no-action" title={post.created}>
                  <i className="fas fa-clock" /> {timeAgoString}
                </span>
                <span className="btn post-tools no-action" title="0">
                  <i className="fas fa-eye" /> {post.views || 0}
                </span>
              </div>
              {(user && user == post.author) && (
                <button className="btn post-tools" onClick={() => setIsEditOpen(true)}>
                  <i className="fas fa-pen" /> 
                </button> 
              )}
              <RewardsButton 
                payoutTimeString={payouTimeString}
                post={post}
                onNewError={onNewError}
                position='right'
                className='post-tools'
              />
              <button className="btn post-tools d-none" onClick={handleShare}>
                <i className="fas fa-gift" /> 
              </button> 
              <ShareButton
                position='right'
                post={post}
                author={post.author}
                permlink={post.permlink}
                onNewError={onNewError} 
                onLogin={toggleLoginModal}
              />
              <VoteButton 
                position='right'
                post={post}
                author={post.author}
                permlink={post.permlink}
                reward_fund={post.reward_fund}
                median_price={post.median_price} 
                setLocalReplies={setLocalReplies} 
                onLogin={toggleLoginModal}
                className='post-tools '
                onNewError={onNewError} 
              />
              <ActiveVotesButton
                position='right'
                post={post}
                onNewError={onNewError}
              />
              <button 
                className="btn post-tools" 
                onClick={(e) => { e.stopPropagation(); if (!isDownloading) handleDownloadVideo(); }}
                title={isDownloading ? `Downloading: ${downloadStatus}` : "Download Video"}
              >
                <i className={`fas ${isDownloading ? 'fa-spinner fa-spin' : 'fa-download'} ${downloadStatus === "Ready!" ? "text-success" : ""}`} />
              </button>
              <button className="btn post-tools" onClick={handleShare}>
                <i className="fas fa-share-alt" /> 
              </button>
            </div>
          );   
          let imageLink =  `https://steemitimages.com/u/${post.author}/avatar`; 
          let public_profile;
          try {
            if (userData.posting_json_metadata) {
              public_profile = JSON.parse(userData.posting_json_metadata);
            } 
          } catch (error) {
            console.log("While getting public profile", error); 
            onNewError(error); 
          }
          try {
            let publicName = (public_profile && public_profile.profile.name) ?public_profile.profile.name : post.author;
            const plan = userPlans.find(u => u.username === post.author);  
            let isPlus = plan?.plan_type?.includes("plus") || false;
            channelDetails = (
              <div className="channel-card">
                <div className="channel-info-preview">
                  <img className="channel-info-image" src={imageLink} alt="User Avatar" />
                  <div className="channel-info-details">
                    <span className="channel-info-name"><a href={`/u/${post.author}`} className='color-letters'>{publicName}</a> {(isPlus) && (<div className="text-muted d-inline-block"  title='Verified Plus member.' style={{marginRight:"2px", cursor:"pointer"}}><VerifiedIcon size={30} className="color-speem" /> </div> )}</span> 
                    <span className="channel-info-username"><a href={`/u/${post.author}`} className='color-letters'>@{post.author} ({getReputation(userData.reputation)})</a> {(post.community && post.community.context && post.community.context.role && post.community.context.role != 'guest') && <span className="text-muted">· {post.community.context.role}</span>}</span>
                    <span className="channel-info-followers">{post.followers_count.follower_count || 0} follower{(post.followers_count.follower_count > 1)? 's':null}{(post.community && post.community.context && post.community.context.title) && <span className="community-label ml-2">{post.community.context.title}</span>}</span>
                  </div>
                </div>
                {!user && (
                  <> 
                    <button className="follow-button" onClick={toggleLoginModal}>Follow</button> 
                  </>
                )} 
                {(user && user != post.author) && (
                  <> 
                    {user && user !== post.author && (
                      <FollowButton author={post.author} onError={onNewError} />
                    )}

                  </>
                )} 
                
              </div>
            );
          } catch (error) {
            console.log("While building channel", error); 
          } 

          labels = (
            < >
              <h2>Labels</h2>
              {isVideo ? (
                <span className='video-label' style={{background:"var(--wild-green)", color:"white"}}>Video</span>
              ) : (
                <span className='video-label' style={{background:"var(--sky-blue)", color:"white"}}>Blog</span>
              )}
              {isComment && (
                <span className='video-label'  style={{background:"var(--sun-yellow)"}}>Comment</span>
              )}
              {isIPFS && (
                <span className='video-label ' style={{background:"var(--cloud-pink)"}}>IPFS</span>
              )}
              {isYoutube && (
                <span className='video-label'  style={{background:"var(--rose-red)", color:"white"}}>YouTube</span>
              )}
              {isShort && (
                <span className='video-label' style={{background:"var(--poison-purple)", color:"white"}}>Short</span>
              )}
            </ >
          );

          
          try {
            const rawMeta = post.json_metadata;
            const parsedMeta = typeof rawMeta === 'string' ? JSON.parse(rawMeta) : (rawMeta || {});
            if (Array.isArray(parsedMeta.tags)) {
              tags = parsedMeta.tags;
            } else if (typeof parsedMeta.tags === 'string') {
              tags = parsedMeta.tags.split(/[,\s]+/).filter(Boolean);
            } else {
              tags = [];
            }
          } catch (error) {
            tags = [];
            console.log("While parsing tags", error);
          }

          try { 
            if (Array.isArray(tags) && tags.length > 0) {
              tagsList = (
                <div className="tags-content">
                  {post.category && <span key={0} className='tag-item community'><a href={`/new/${post.category}`}>in {post.community?post.community.title:post.category}</a></span>}
                  {tags.map((tag, index) => {
                    if (tag != "") {
                      return (
                        <span key={index} className='tag-item'><a href={`/new/${tag}`}>#{tag}</a></span>
                      )
                    } 
                  })}
                </div>
              );
            }
          } catch (error) {
            console.log("While building tags", error);
          } 
        } else {
          exist = false; 
          videoEmbed = (
            <>
              <div className='post-empty'>This post doesn't exist.</div>
            </> 
          ) ; 
        }
      } catch (error) {
        onNewError(error); 
        videoEmbed = (
          <>
            <div className='post-empty'>Something went wrong.</div>
          </> 
        ) ; 
      }
    }else {
      videoEmbed = null; // handled inline with skeleton below
    } 
    // }, []);
    if (errorMessage) {
      console.log(errorMessage);
    }
    if (!exist) {
      return (
            <>
              <div className='post-empty'>This post doesn't exist.</div>
            </> 
          );
    }
    
    return (
      <div className='p-0 bg-white content-section row m-0'> 
        <SEO 
          title={post?.title}
          description={BodyText}
          image={post?.cover}
          type="article"
          author={post?.author}
          publishedTime={post?.created}
          tags={tags}
        />
        <div className="p-0 col-12 col-md-7 col-lg-8">
          {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

          {/* ─── Skeleton Layout ─── */}
          {isLoading ? (
            <>
              {/* Video placeholder */}
              <Skeleton height={320} style={{ borderRadius: 0, display: 'block' }} />

              <div style={{ padding: '0 1rem' }}>
                {/* Title */}
                <Skeleton height={28} width="80%" className="mt-3 mb-2" />

                {/* Stat row */}
                <div className="d-flex gap-2 mb-3" style={{ gap: '8px' }}>
                  <Skeleton height={32} width={90} style={{ borderRadius: 8 }} />
                  <Skeleton height={32} width={90} style={{ borderRadius: 8 }} />
                  <Skeleton height={32} width={90} style={{ borderRadius: 8 }} />
                  <Skeleton height={32} width={90} style={{ borderRadius: 8 }} />
                </div>

                {/* Channel card */}
                <div className="channel-card" style={{ pointerEvents: 'none' }}>
                  <div className="channel-info-preview">
                    <Skeleton circle height={56} width={56} className="channel-info-image" />
                    <div className="channel-info-details" style={{ flex: 1, marginLeft: 12 }}>
                      <Skeleton height={18} width={160} className="mb-1" />
                      <Skeleton height={13} width={110} className="mb-1" />
                      <Skeleton height={13} width={80} />
                    </div>
                  </div>
                  <Skeleton height={34} width={90} style={{ borderRadius: 8 }} />
                </div>

                {/* Description */}
                <div className="mt-3">
                  <Skeleton height={16} className="mb-2" />
                  <Skeleton height={16} width="90%" className="mb-2" />
                  <Skeleton height={16} width="75%" className="mb-2" />
                  <Skeleton height={16} width="60%" />
                </div>
              </div>
            </>
          ) : (
            <>
              {videoEmbed}
              
              {isIPFS && (
                <div className="menu-tabs-compact transparent mt-2">
                  <button
                    className={classnames('tab-button', { active: activeTab === 'post' })}
                    onClick={() => setActiveTab('post')}
                  >
                    Post
                  </button>
                  <button
                    className={classnames('tab-button', { active: activeTab === 'transcription' })}
                    onClick={() => setActiveTab('transcription')}
                  >
                    Transcription 
                   <i className="ai-icon-gradient ml-1"></i>
                  </button>
                </div>
              )}

              <div className="transcription-container">
                {activeTab === 'post' ? (
                  <div style={{padding:'0 1rem'}}>
                    {title}
                    {postStatus}
                    {postButtons} 
                    {channelDetails} 
                    {tagsList}
                    {postDescription} 
                    {post && (
                      <PostReplies
                        post={post} 
                        onError={onNewError}
                        userPlans={userPlans}
                        onLogin={toggleLoginModal} 
                        localReplies={localReplies}
                        setLocalReplies={setLocalReplies} 
                      /> 
                    )}
                  </div>
                ) : (
                  <div style={{padding:'1rem'}}>
                    {aiTranscription ? (
                      <div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            {aiLanguage && <span className="badge badge-info mr-2">Language: {aiLanguage.toUpperCase()}</span>}
                            <span className="badge badge-light border">AI Generated</span>
                          </div>
                          
                          {aiSrt && (
                            <div className="script-mode-toggle">
                              <button 
                                className={`btn btn-sm ${transcriptionViewMode === 'text' ? 'active' : ''}`}
                                onClick={() => setTranscriptionViewMode('text')}
                              >Text</button>
                              <button 
                                className={`btn btn-sm ${transcriptionViewMode === 'srt' ? 'active' : ''}`}
                                onClick={() => setTranscriptionViewMode('srt')}
                              >Subtitles</button>
                            </div>
                          )}
                        </div>
                        
                        <div className="transcription-script-view mb-3">
                          {transcriptionViewMode === 'srt' && aiSrt ? aiSrt.replace(/,\d{3}/g, '') : aiTranscription}
                        </div>
                        
                        <div className="text-muted small text-center mt-2 pb-2">
                          <i className="fas fa-exclamation-triangle mr-1"></i>
                          Warning: This transcription was generated automatically by AI and may contain inaccuracies.
                        </div>
                      </div>
                    ) : (
                      <div className="text-center py-5">
                          <i className="ai-icon-muted mb-3 opacity-5" style={{fontSize: '1em'}}></i>
                          <h4 className="text-muted">No transcription available</h4>
                          <p className="text-muted mb-4">This video doesn't have an AI transcription yet.</p>
                          
                          {(() => {
                            const plan = userPlans.find((u: any) => u.username === user);
                            let isCurrentUserPlus = plan?.plan_type?.includes("plus") || false;
                            
                            if (!user) {
                              return <button className="btn btn-primary" onClick={toggleLoginModal}>Login to Use AI</button>;
                            }
                            
                            if (isCurrentUserPlus) {
                                return (
                                  <div className="d-flex flex-column align-items-center">
                                    {aiProcessing ? (
                                      <div className="ai-status-card animate__animated animate__fadeIn">
                                        <div className="ai-pulse-indicator"></div>
                                        <span className="text-speem font-weight-bold tiny-text mt-1">{aiStatus}...</span>
                                        <Spinner size="sm" className="opacity-5" color="secondary" />
                                      </div>
                                    ) : (
                                      <button 
                                     className="btn-ai-action" 
                                     onClick={generateTranscriptionFromIPFS}
                                   >
                                       Generate Transcription 
                                       <i className="ai-icon-white ml-2"></i>
                                   </button>
                                    )}
                                  </div>
                                );
                            } else {
                                return (
                                    <div className="alert alert-secondary d-inline-block">
                                        <i className="fas fa-lock text-warning mr-2"></i>
                                        Requires <strong>Speak Plus</strong> to generate new AI transcripts.
                                    </div>
                                );
                            }
                          })()}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </>
          )}

          <LoginModal
            isShowing={isOpenLoginModal}
            hide={toggleLoginModal}
          />
          {post && (
            <ContentEditPostModal
              isShowing={isEditOpen}
              isComment={isComment}
              hide={() => setIsEditOpen(false)}
              title={post.title}
              description={post.body}
              tags={tags || []}
              post={post}
              onSuccess={(updatedPost)=> {
                setIsEditOpen(false);
                dispatch(fetchPost(updatedPost.author, updatedPost.permlink)); 
              }}
            />
          )}
          
        </div>
        
        <div className="col-12 col-md-5 col-lg-4">
          {/* Sidebar skeleton */}
          {isLoading ? (
            <>
              <Skeleton height={22} width={80} className="mt-2 mb-3" />
              {[1, 2, 3].map(i => (
                <div key={i} className="mb-3">
                  <Skeleton height={140} className="mb-2" style={{ borderRadius: 8 }} />
                  <div className="d-flex align-items-center mb-1" style={{ gap: 8 }}>
                    <Skeleton circle height={28} width={28} />
                    <Skeleton height={14} width="55%" />
                  </div>
                  <Skeleton height={16} width="85%" className="mb-1" />
                  <Skeleton height={12} width="40%" />
                </div>
              ))}
            </>
          ) : (
            <>
              {labels} 
              <AdSense type="horizontal" className="mt-4" />
              <h2 className='mt-2'>Suggested</h2>
              {(suggestedPosts && suggestedPosts.length > 0) && (
              <>
                {suggestedPosts.map((item) => {
                  if (post && (post.author != item.author && post.permlink != item.permlink)) { 
                    const postUrl = `/@${item.author}/${item.permlink}`; 
                    const view = views.find(v => v.url === postUrl);
                    const viewsCount = view ? view.count : 0;
                    const plan = userPlans.find(u => u.username === post.author);  
                    let isPlus = plan?.plan_type?.includes("plus") || false;
                    let postData = {
                      ...item, 
                      views:viewsCount 
                    }; 
                    return ( 
                    <div key={`${item.author}/${item.permlink}`} className=" " 
                    ref={()=>{} }>
                      <PostVideoItem post={postData} isPlus={isPlus}  />
                    </div>)
                  }
                  
                })} 
              </>
            )}
            </>
          )}
        </div> 
      </div>
    );
}
